import React from "react";
import { Link } from "react-router-dom";
const getPointsColumns = (deleteFunc) => {
  return [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,

      width: "10%",
    },
    {
      title: "Title",
      dataIndex: "actionName",
      sorter: (a, b) => a.actionName.length - b.actionName.length,
      width: "25%",
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
      width: "25%",
    },
    {
      title: "Reward Points",
      dataIndex: "rewardPoints",
      sorter: (a, b) => a.rewardPoints.length - b.rewardPoints.length,
      width: "25%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={`/addPoints/${record.id}`}>
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => deleteFunc(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "15%",
    },
  ];
};

export default getPointsColumns;
